import { DatePipe } from '@angular/common';
import { Cart } from './../cart.model';
import { Component, OnInit, Input } from '@angular/core';
import { firestore } from 'firebase';

@Component({
  selector: 'app-cart-data-renderer',
  templateUrl: './cart-data-renderer.component.html',
  styleUrls: ['./cart-data-renderer.component.css']
})
export class CartDataRendererComponent implements OnInit {

  items: { key: string, value: string }[] = [];

  @Input()
  cart: Cart;

  @Input()
  keys: string[];

  constructor(private datePipe: DatePipe) { }

  private valueToString(value): string {
    if (value) {
      if (value instanceof firestore.Timestamp) {
        const ts = (value as firestore.Timestamp)
        return this.datePipe.transform(ts.toDate(), "dd/MM/yyyy");
      } else {
        return value.toString();
      }
    } else {
      return "—";
    }
  }

  ngOnInit() {
    for (const key of (this.keys || Object.keys(this.cart))) {
      if (this.cart.hasOwnProperty(key) && key !== "typeform1" && key !== "typeform2") {
        this.items.push({
          key, value: this.valueToString(this.cart[key])
        });
      }
    }

    if (!this.keys || "typeform1" in this.keys) {
      this.items.push({
        key: "typeform1", value: this.cart.typeform1 ? this.cart.typeform1.id : null
      });
    }

    if (!this.keys || "typeform2" in this.keys) {
      this.items.push({
        key: "typeform2", value: this.cart.typeform2 ? this.cart.typeform2.id : null
      });
    }

  }

}
